import { FunctionComponent } from 'react';
import { useMount } from 'react-use';
import { useTranslation } from 'react-i18next';

import { Helmet } from 'react-helmet';
import _ from 'lodash';
import { Link, useParams } from 'react-router-dom';

import { Content, SidebarRight, Menu } from '~components/blog';

import { useYaMetrica } from '~frontend/provider/yametrica';

import '../../scss/pages/_news.scss';
import { useConfig } from '~frontend/components/hooks';

const Blog: FunctionComponent = () => {
  const { tag, search } = useParams();
  const getConfig = useConfig();

  const { t } = useTranslation();

  const { reachGoal } = useYaMetrica();

  useMount(() => {
    reachGoal('goPageBlog');
  });

  const h1 = tag ? t(`blog tag ${tag}`) : t('page-news h1');

  return (
    <>
      <Helmet>
        {getConfig?.isEU ? (
          <title>{t('blog_title_seo_com')}</title>
        ) : (
          <title>{t('blog_title_seo_io')}</title>
        )}
        {getConfig?.isEU ? (
          <meta name="description" content={t('blog_desc_seo_com')} />
        ) : (
          <meta name="description" content={t('blog_desc_seo_io')} />
        )}
      </Helmet>
      <Menu />
      <div className="page-news">
        <div className="breadcrumbs">
          <Link to="/">CSCASE</Link>
          <Link to="/blog">{t('blog')}</Link>
          {tag ? (
            <Link to={`/blog/tag/${tag}`}>{t(`blog tag ${tag}`)}</Link>
          ) : (
            search && <Link to={`/blog/search/${tag}`}>{search}</Link>
          )}
        </div>
        <h1>{h1}</h1>
        <div className="page-news-wrapper">
          <section className="page-news-content">
            <Content />
          </section>
          <SidebarRight />
        </div>
      </div>
    </>
  );
};

export default Blog;
